/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './login-result.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from 'nm-socle-application/app/components/login/login-result/login-result.component';
import * as i4 from 'ng2-translate/src/translate.directive';
import * as i5 from 'ng2-translate/src/translate.service';
import * as i6 from 'nm-socle-application/app/services/geo.service';
import * as i7 from 'nm-socle-application/app/shared/services/template-init.service';
const styles_LoginResultComponent:any[] = [i0.styles];
export const RenderType_LoginResultComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_LoginResultComponent,data:{}});
function View_LoginResultComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),0,'div',([] as any[]),
      [[8,'className',0]],(null as any),(null as any),(null as any),(null as any)))],
      (null as any),(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = i1.ɵinlineInterpolate(2,'icone fa fa-4x ',_co.icon,' centered ',
            _co.color,'');
        _ck(_v,0,0,currVal_0);
      });
}
export function View_LoginResultComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(2,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),14,'div',[['class',
      'container']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_LoginResultComponent_1)),i1.ɵdid(3,16384,
          (null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(5,
          0,(null as any),(null as any),8,'div',[['class','footer form-group']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['\n        '])),(_l()(),i1.ɵeld(7,0,(null as any),(null as any),
          5,'button',[['class','btn']],[[8,'disabled',0]],[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i3.LoginResultComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.goLoginForm()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n            '])),
      (_l()(),i1.ɵeld(9,0,(null as any),(null as any),2,'span',[['translate','']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(10,8536064,(null as any),0,i4.TranslateDirective,[i5.TranslateService,
          i1.ElementRef],{translate:[0,'translate']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['login.back '])),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i3.LoginResultComponent = _v.component;
    const currVal_0:any = ((_co.icon != (undefined as any)) && (_co.icon != ''));
    _ck(_v,3,0,currVal_0);
    const currVal_2:any = '';
    _ck(_v,10,0,currVal_2);
  },(_ck,_v) => {
    var _co:i3.LoginResultComponent = _v.component;
    const currVal_1:any = _co.geoServices.isRequesting;
    _ck(_v,7,0,currVal_1);
  });
}
export function View_LoginResultComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'login-result',
      ([] as any[]),(null as any),(null as any),(null as any),View_LoginResultComponent_0,
      RenderType_LoginResultComponent)),i1.ɵdid(1,3391488,(null as any),0,i3.LoginResultComponent,
      [i6.GeoServices,i1.ChangeDetectorRef,i7.TemplateInitService],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const LoginResultComponentNgFactory:i1.ComponentFactory<i3.LoginResultComponent> = i1.ɵccf('login-result',
    i3.LoginResultComponent,View_LoginResultComponent_Host_0,{title:'title',icon:'icon',
        color:'color',misc:'misc'},{closeEvent:'closeEvent',internalStateEvent:'internalStateEvent'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/src/$$_gendir/node_modules/nm-socle-application/app/components/login/login-result/login-result.component.ngfactory.ts